import React from 'react';

import {
  FindListingsResponse,
  ListingRequest,
} from '@klokhuis/core/ApiClient/Klokhuis';

import { getFilterCount } from '../pages/Listings/components/FilterUtils';
import { FilterActionTypes, ListingActionTypes } from './types';

import { ListingsContext } from './ListingsContext';
import { mainReducer } from './Reducer';

export const ListingsProvider = ({
  children,
  initialListings,
  initialFilters,
  initialFavoriteIds,
}: {
  children: React.ReactNode;
  initialListings: FindListingsResponse | null;
  initialFilters: ListingRequest | null;
  initialFavoriteIds?: number[];
}) => {
  // Save the search criteria from serverside props
  const initialState = {
    filterResult: {
      count: initialFilters ? getFilterCount(initialFilters) : 0,
      filters: initialFilters || {},
    },
    listingsResult: {
      isLoading: false,
      listings: initialListings || {},
    },
  };
  const [listingsState, dispatch] = React.useReducer(mainReducer, initialState);
  const [favoriteIds] = React.useState<Set<number>>(
    () => new Set(initialFavoriteIds || []),
  );

  // Update state when initialListings or initialFilters change (e.g., on route change)
  React.useEffect(() => {
    dispatch({
      type: ListingActionTypes.UPDATE_LISTING,
      payload: initialListings || {},
    });
    dispatch({
      type: FilterActionTypes.UPDATE_FILTER,
      payload: initialFilters || {},
    });
    if (initialFilters) {
      dispatch({
        type: FilterActionTypes.UPDATE_FILTER_COUNT,
        payload: getFilterCount(initialFilters),
      });
    }
  }, [initialListings, initialFilters]);

  const value = React.useMemo(
    () => ({ listingsState, dispatch, favoriteIds }),
    [listingsState, favoriteIds],
  );

  return (
    <ListingsContext.Provider value={value}>
      {children}
    </ListingsContext.Provider>
  );
};
